import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { ISessionState } from './ISessionState';
import { StateService } from '../../state.service';
import { AuthenticationService } from '../../../core/security/services/authentication.service';
import { USER_AUTHENTICATION_UPDATE } from './session.action.const';
import { IdentitySession } from '../../../core/security/model/identity-session.model';

@Injectable()
export class SessionAction {
    constructor(private ngRedux: NgRedux<ISessionState>,
        private stateService: StateService,
        private authService: AuthenticationService) {
    }

    login(loginResponse) {
        if (loginResponse.status === 'SUCCESS') {
            this.authService.authenticate(loginResponse).subscribe((result) => {
                if (result) {
                    const session = this.authService.getSessionValue();
                    this.userAuthenticationUpdate(session);
                }
            });
        }
    }

    userAuthenticationUpdate(identitySession: IdentitySession) {
        this.ngRedux.dispatch({
            type: USER_AUTHENTICATION_UPDATE,
            identitySession: identitySession
        });
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/session/session.action.ts